import { TratamentoSementesFormValues } from '../../../@types';
import makeForm from '../../../components/Form';
import Yup from '../../../utils/yup';

export const validationSchema = Yup.object().shape({
  propriedade: Yup.object().required(),
  safra: Yup.object().required(),
  atividade: Yup.object().required(),
  clienteAgrogestao: Yup.boolean().nullable(),
  tratamentos: Yup.array().min(1),
});

export const defaultValues: TratamentoSementesFormValues = {
  propriedade: undefined,
  safra: undefined,
  atividade: undefined,
  clienteAgrogestao: false,
  tratamentos: [],
};

export const Form = makeForm<TratamentoSementesFormValues>();
